// src/blocks/icon/SVGs/arrow.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ArrowSVG = ({
  title = "Arrow Icon",
  desc = "Arrow Icon",
  descId,
  width = 16,
  height = 16,
  direction,
  className,
  ...props
}) => {
  const titleId = React.useId();
  const decriptionId = React.useId();
  let tilt = "rotate-0";
  switch (direction) {
    case "up":
      tilt = "rotate-270";
      break;
    case "down":
      tilt = "rotate-90";
      break;
    case "left":
      tilt = "rotate-180";
      break;
    case "right":
      tilt = "rotate-0";
      break;
    case "top-right":
      tilt = "rotate-315";
      break;
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 16 16",
      className: `${tilt} ${className}`,
      fill: "none",
      "aria-labelledby": titleId,
      "aria-describedby": decriptionId,
      ...props,
      children: [
        desc ? /* @__PURE__ */ jsx("desc", { id: decriptionId, children: desc }) : null,
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "currentColor",
            d: "m9.238 2.67 4.933 4.858H0v.944h14.17L9.239 13.33l.68.67L16 8 9.918 2l-.68.67Z"
          }
        )
      ]
    }
  );
};
var arrow_default = ArrowSVG;

export {
  arrow_default
};
